import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-header-fullscreen",
  templateUrl: "./header-fullscreen.component.html",
  styleUrls: ["./header-fullscreen.component.scss"],
  standalone: false,
})
export class HeaderFullscreenComponent implements OnInit {
  isFullscreen = false;

  constructor() {}

  ngOnInit() {}

  toggleScreen(): void {
    const elem = document.documentElement;

    if (!document.fullscreenElement) {
      elem.requestFullscreen().catch((err) => {
        console.error(`Error al entrar a fullscreen: ${err.message}`);
      });
    } else {
      document.exitFullscreen();
    }
  }
}
